import { FormattedMessage, useIntl } from "react-intl";
import {
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from "@fluentui/react-components";

import type { DarkquellInferredSkill } from "@aglocal/schema/Darkquell";

import Callout from "@aglocal/web/components/Callout";

import SkillPills from "@/components/SkillPills";
import { PredictionResponse } from "@aglocal/schema/SkillClassifier";

export interface SkillsAccordionItemProps {
  name: unknown;
  skills: readonly DarkquellInferredSkill[];
  negativeSkills: readonly PredictionResponse[];
}

export default function SkillsAccordionItem({
  name,
  skills,
  negativeSkills,
}: SkillsAccordionItemProps) {
  const { $t } = useIntl();
  return (
    <AccordionItem value={name}>
      <AccordionHeader>
        <FormattedMessage
          defaultMessage="Skills"
          description="Header of the post-meeting wrap-up section listing the skills detected in the conversation."
        />
      </AccordionHeader>
      <AccordionPanel>
        {skills.length === 0 ? (
          <Callout
            intent="warning"
            title={$t({
              defaultMessage: "No skills found",
              description:
                "Shown when no skills have been detected in the conversation yet.",
            })}
          />
        ) : (
          <SkillPills skills={skills} negativeSkills={negativeSkills} />
        )}
      </AccordionPanel>
    </AccordionItem>
  );
}
